// @ts-ignore
const API_BASE_ADDRESS = window.app.env.API_URL;
export default class Api {
    static getOrderStatus(orderNumber:string){
        // const controller = new AbortController();
        // const signal = controller.signal;
        // setTimeout(()=>controller.abort(),30000);
        return fetch(`${API_BASE_ADDRESS}/${orderNumber}`,{
            method:'GET'
        });
    }
    static getTranslations(domainID:number, preview: boolean, webLink:string){
        // const controller = new AbortController();
        // const signal = controller.signal;
        // setTimeout(()=>controller.abort(),30000);
        if(!preview)
            return fetch(`${API_BASE_ADDRESS}/translations/${domainID}/${webLink}`,{
            method:'GET'
        });
        return fetch(`${API_BASE_ADDRESS}/translationsPreview/${domainID}/${webLink}`,{
            method:'GET'
        });
    }

    static getStyles(domainID: number, storeID:number, preview:boolean){
        // const controller = new AbortController();
        // const signal = controller.signal;
        // setTimeout(()=>controller.abort(),30000);
        if(!preview)
            return fetch(`${API_BASE_ADDRESS}/weblink/${domainID}/${storeID}`,{
            method:'GET'
        });
        return fetch(`${API_BASE_ADDRESS}/weblinkPreview/${domainID}`,{
            method:'GET'
        });
    }

    static getStoreDeliveryOptions(webLink: string, storeId: number, preview:boolean){
        // const controller = new AbortController();
        // const signal = controller.signal;
        // setTimeout(()=>controller.abort(),30000);
        if(!preview)
            return fetch(`${API_BASE_ADDRESS}/storeDeliveryOptions/${webLink}`,{
            method:'GET'
        });
        return fetch(`${API_BASE_ADDRESS}/storeDeliveryOptionsPreview/${storeId}`,{
            method:'GET'
        });
    }

    static updateOrder(orderCode:any,text:any, deliveryOption: any){
        // const controller = new AbortController();
        // const signal = controller.signal;
        // setTimeout(()=>controller.abort(),30000);
        return fetch(`${API_BASE_ADDRESS}/${orderCode}`,{
            method:'PATCH',
            body: JSON.stringify({text, deliveryOption}),
            headers: {'Content-Type': 'application/json'}
        });
    }

    static updateCarPlates(linkCode:any,carPlates:any,deliveryOption:any){
        // const controller = new AbortController();
        // const signal = controller.signal;
        // setTimeout(()=>controller.abort(),30000);
        return fetch(`${API_BASE_ADDRESS}/changeCarPlate/${linkCode}/webLink`, {
            method:'PATCH',
            body:JSON.stringify({carPlates: carPlates, deliveryOption: deliveryOption}),
            headers: {'Content-Type': 'application/json'}
        })
    }
}
